import produce from 'immer';
import { ReducerAction } from 'store/modules/types';

// TYPES
import { Types, CadastrarParametroSistema } from './types';

export const INITIAL_STATE: CadastrarParametroSistema = {
	status: 0,
	data: null,
};

export default function cadastrarParametroSistemaReducer(
	state = INITIAL_STATE,
	action: ReducerAction,
): CadastrarParametroSistema {
	return produce(state, draft => {
		switch (action.type) {
			case Types.CADASTRAR_PARAMETRO_SISTEMA: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			case Types.CADASTRAR_PARAMETRO_SISTEMA_SUCCESS: {
				draft.status = action.payload.status;
				draft.data = action.payload.data;
				break;
			}

			case Types.CADASTRAR_PARAMETRO_SISTEMA_FAILURE: {
				draft.status = 400;
				break;
			}

			case Types.CADASTRAR_PARAMETRO_SISTEMA_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			default:
		}
	});
}
